export const ADD_NOTIFICATION_TEMPLATE = "ADD_NOTIFICATION_TEMPLATE"
export const GET_NOTIFICATION_TEMPLATE = "GET_NOTIFICATION_TEMPLATE"
export const ALL_NOTIFICATION_TEMPLATE = "ALL_NOTIFICATION_TEMPLATE"
export const EDIT_NOTIFICATION_TEMPLATE = "EDIT_NOTIFICATION_TEMPLATE"